<template>
  <div class="container-fluid login">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info">
        <div class="logo">
          <a :href="lpUrl" class="ico-iouu" target="_blank" title="IOUU"></a>
        </div>
        <div class="row justify-content-center d-flex align-items-center">
          <div class="col-12 col-lg-10 d-flex flex-column align-items-center">
          <h1>Existe uma maneira melhor de investir...</h1>
            <p>
              Você mesmo consegue administrar seus investimentos e escolher o melhor lugar para colocar o seu dinheiro. 
              Encontre a melhor oportunidade para seu crescimento.
            </p>
          </div>        
        </div>
        <social-network/>

      </div>
      <div class="col-12 col-md-12 col-lg-7 d-flex flex-column form">
        <header class="align-self-center align-self-md-end">
          Já tem uma conta?
          <router-link to="login" class="btn btn-outline-primary">Entrar</router-link>
        </header>
        <div class="row justify-content-center d-flex align-items-center">
          <div class="col-12 col-md-8 col-lg-5 text-center">
            <h2>Escolha uma senha</h2>
            <span class="text">Insira uma senha para entrar.</span>
            <form @submit.prevent="signUp" id="form-criar-senha">
              
              <input id="name" type="hidden" name="firstname" :value="this.name">
              <input id="email" type="hidden" name="email" :value="this.email">
            
              <div class="form-group text-left">
                <label for="password">Senha</label> 
                <password-field id="Password" v-model="password"/>
              </div>
              <div class="form-check text-left d-flex justify-content-center">
                <div class="checkboxContainer">
                  <input class="form-check-input" type="checkbox" v-model="enabled">
                  <span class="checkmark"></span>
                </div>
                <label class="form-check-label p-0">
                  Eu "CONCORDO" com os <a :href="lpUrl+'/termos-e-condicoes/'" target="_blank">Termos e condições</a> e <a :href="lpUrl+'/politica-de-privacidade/'" target="_blank">Política de privacidade</a> da IOUU.
                </label>
              </div>
              <button type="submit" :disabled="!enabled || !EmailConfirmado" class="btn btn-lg btn-primary" >Entrar</button>
            </form>
          </div>
        </div>
      </div>      
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../assets/styles/iouu/_variables";
  .login {
    .info {
      background:url(/static/assets/images/bg-login.jpg) top center no-repeat, linear-gradient(to bottom right, $c3, $c2 85%);
      background-size: cover;
      // background-blend-mode: multiply;
      text-align: center;
      color: #fff;
    }
  }

  // CHECKBOX - CUSTOM 
	.checkboxContainer {
		&{
		  display: block;
		  position: relative;
		  cursor: pointer;
		  -webkit-user-select: none;
		  -moz-user-select: none;
		  -ms-user-select: none;
			user-select: none;
			width: 20px;
			height: 20px;
			margin-right: 10px;
    }
    
		&:hover {
		  input ~ .checkmark {
			background-color: #ccc;
		  }
		}
	
		input {
		  position: absolute !important;
		  opacity: 0;
		  width: 20px;
		  height: 20px;
		  cursor: pointer;
			left: 0;
      margin-left: 0;
      top: -4px;
	
		  &:checked ~ .checkmark {
			background-color: #41D3BF;
		  }
		}
	
		.checkmark {
		  position: absolute;
		  /* top: -4px; */
		  left: 0;
		  height: 20px;
		  width: 20px;
		  background-color: #eee;
		  border-radius: 6px;
		  cursor: pointer;
		  pointer-events: none;
	
		  &::after {
			content: "";
			position: absolute;
			display: none;
			left: 5px;
			top: 2px;
			width: 6px;
			height: 11px;
			border: solid white;
			border-width: 0 3px 3px 0;
			-webkit-transform: rotate(45deg);
			-ms-transform: rotate(45deg);
			transform: rotate(45deg);
		  }
	
		}
	
		input:checked ~ .checkmark:after {
		  display: block;
		}
	}
	// END CHECKBOX - CUSTOM
</style>

<script>
import ApiClient from '@/utils/api-client'
import SocialNetwork from '@/components/SocialNetwork'
import ArrayHelper from '@/utils/array-helper'
import PasswordField from '@/components/PasswordField'
import HubConsultaClient from '@/utils/hub-consulta-client.js'
import UserApi from '../services/api/user';

export default {
  data() {
    return {
      lpUrl:process.env.LP_URL,
      enabled: false,
      EmailConfirmado: false,
      password: '',
      email: '',
      name: '',
      user: {}
    }
  },
  components: {
    SocialNetwork, PasswordField
  },
  created() {

    const email = this.getQueryString('email').toLowerCase()
    const name = this.getQueryString('name').toLowerCase()

    this.email = email
    this.name = name
    
    console.log(email)

    this.emailValidate(email)

    this.user = this.getUser(email);
    console.log('f ', this.user)
  },
  methods: {
    async getUser(email) {
      return await UserApi.GetUserByEmail(email);
    },
    emailValidate(email) { 
      email = email.toLowerCase().trim();
        
      HubConsultaClient.theCheckerPost(email)
        .then(resposta => {

          if(resposta == "Entregável") this.EmailConfirmado = true

          else this.$Notify.error("Email informado é inválido!")

        })
        .catch((resposta) => {

          this.EmailConfirmado = true
          
        });
    },
    getQueryString(name) {
        const url = window.location.href

        name = name.replace(/[\[\]]/g, '\\$&');

        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')

        const resp = regex.exec(url)

        if (!resp) return null

        if (!resp[2]) return ''

        return decodeURIComponent(resp[2].replace(/\+/g, ' '))
    },
    passwordIsValid() {

      if(this.password.length < 6) {

        this.$Notify.error("A senha deve conter mais de 6 digitos!")
        $("#inputPassword").addClass("animated shake")
        $("#inputPassword").addClass("emailinvalido")

        return false

      }

      else {
        $("#inputPassword").removeClass("animated")
        $("#inputPassword").removeClass("shake")
        $("#inputPassword").removeClass("emailinvalido")

        return true
      }

    },
    async signUp() {

        if(!this.passwordIsValid()) return 

        const email = this.getQueryString('email').toLowerCase()
        const name = this.getQueryString('name')

        this.$store.dispatch('signup', {name, email, password: this.password})
          .then(() => {
            const now = new Date();

            mixpanel.people.set({
              'USER_ID': this.user.id,
              'sign_up_date': now,
              'email': email,
              'name': name,
              'Tipo': 'Investidor',
            });

            mixpanel.identify(currentUser._id);

            mixpanel.track("NEW_PASSWORD", {
              timestamp: now
            });

            console.log('mix ', mixpanel);
            
            this.$router.push("/investimentos/oportunidades/");
          })
          .catch(error => {
            const errorMessages = error.response.data.Msg
            
            this.$Notify.error(errorMessages)
          })

        // CADASTRA CONTATO EM ACTIVE CAMPAIN
        HubConsultaClient.CadastrarActive(email)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/CriarContaSenha.vue